// extracted by mini-css-extract-plugin
export default {"col":"Accessibility_col__9KMEL","arrow":"Accessibility_arrow__8K2qS","lists":"Accessibility_lists__00nBA"};